module.exports = __webpack_public_path__ + "img/macbook.9d47a09c.png";